import React from 'react';
import { Link } from 'react-router-dom';

import './css/Footer.css'

import { BOOK_DEMO_LABEL, CONTACT_EMAIL, TALK_TO_US_URL } from './contact'

// The mark, light version for the black ground, as in the menu bar.
const logoSrc: string = require( './images/logos/Logo.002.Dark.png' )
const linkedInSrc: string = require( './images/Icon.LinkedIn.Light.png' )

// Where else to go from the bottom of a page: the four sections of the home
// page, in their order, and the other pages of the site. Hash links work
// from any page — App.tsx scrolls to the section once the home has rendered.
interface FooterLink {
	label: string
	to: string
}

interface FooterGroup {
	title: string
	links: FooterLink[]
}

const GROUPS: FooterGroup[] = [
	{
		title: 'Product',
		links: [
			{ label: 'Traceable copies', to: '/#trace' },
			{ label: 'Self-hosted', to: '/#self-hosted' },
			{ label: 'Very large volumes', to: '/#speed' },
			{ label: 'Invisible watermark', to: '/#mark' },
		],
	},
	{
		title: 'Site',
		links: [
			{ label: 'Technology', to: '/technology' },
			{ label: 'Performances', to: '/performances' },
			{ label: 'Pricing', to: '/pricing' },
			{ label: 'FAQ', to: '/faq' },
		],
	},
]


export function Footer(): React.JSX.Element {

	return (
		<footer className="Pane-Light Footer" >
			<div className="Container" >

				<div className="Footer-Top" >

					<div className="Footer-Brand" >
						<Link to="/" className="Footer-Logo" aria-label="underlayer home" >
							<img className="Footer-Logo-Image" src={ logoSrc } alt="underlayer" />
						</Link>
						<div className="Footer-Tagline" >An invisible mark on every image you serve.</div>
					</div>

					<nav className="Footer-Groups" aria-label="Footer" >
						{ GROUPS.map( ( group: FooterGroup ): React.JSX.Element => (
							<div className="Footer-Group" key={ group.title } >
								<div className="Footer-Group-Title" >{ group.title }</div>
								<ul className="Footer-Links" >
									{ group.links.map( ( link: FooterLink ): React.JSX.Element => (
										<li key={ link.to } >
											<Link to={ link.to } className="Footer-Link" >{ link.label }</Link>
										</li>
									) ) }
								</ul>
							</div>
						) ) }

						<div className="Footer-Group Footer-Group-Contact" >
							<div className="Footer-Group-Title" >Get in touch</div>
							<div className="Footer-Ctas" >
								<a href={ TALK_TO_US_URL } target="_blank" rel="noopener noreferrer" className="Footer-Cta Footer-Cta-Primary" >{ BOOK_DEMO_LABEL }</a>
								<Link to="/contact" className="Footer-Cta Footer-Cta-Secondary" >Contact</Link>
							</div>
							<a href={ `mailto:${ CONTACT_EMAIL }` } className="Footer-Link Footer-Email" >{ CONTACT_EMAIL }</a>
						</div>
					</nav>

				</div>

				<div className="Footer-Bottom" >
					<span className="Footer-Copyright" >© 2026 underlayer. All rights reserved.</span>
					<a
						href="https://www.linkedin.com/company/underlayerai"
						target="_blank"
						rel="noopener noreferrer"
						className="Footer-Social"
						aria-label="underlayer on LinkedIn"
					>
						<img src={ linkedInSrc } alt="" />
					</a>
				</div>

			</div>
		</footer>
	)
}
